/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { getIdentity } from 'actions/common';

import BlueHeaderOnWhiteLayout from 'layouts/BlueHeaderOnWhite';

import useIsMobile from 'hooks/browser/useIsMobile';

import SecureAccountOptions from 'containers/SecureAccountOptions';
import connect from './index.connect';

const SecureAccountWorkflowStep = ({
  active,
  updateState,
  loadIdentity
}) => {
  // Hooks
  const isMobile = useIsMobile();
  const [secureAccountMethods, userSecureAccountMethods ] = useSelector(
    (state) => {
      const identity = getIdentity(state);

      return [
        identity.secureAccountMethods,
        identity.userSecureAccountMethods
      ];
    },
    shallowEqual
  );

  useEffect(() => {
    updateState('loaded');
  }, []);

  const isSecured = userSecureAccountMethods?.some(m => secureAccountMethods?.includes(m));

  useEffect(() => {
    if (isSecured) {
      updateState('completed');
    }
  }, [isSecured]);

  // Render
  if (!active) return <></>;

  const onComplete = () => loadIdentity();

  return (
    <BlueHeaderOnWhiteLayout
      backgroundColor="#f7f7f7"
      contentWidth={isMobile ? null : 650}
      hideLoginLink={true}
    >
      <div className="viewstrap">
        <div style={{
          paddingTop: isMobile ? '20px' : '56px',
          paddingLeft: isMobile ? '5px' : null,
          paddingRight: isMobile ? '5px' : null
        }}>
          <SecureAccountOptions
            secureAccountMethods={secureAccountMethods}
            userSecureAccountMethods={userSecureAccountMethods}
            onComplete={onComplete} />
        </div>
      </div>
    </BlueHeaderOnWhiteLayout>
  );
};

export default connect(SecureAccountWorkflowStep);
